export default __webpack_public_path__ + "static/media/profile-page-pig.b32564ce.png";